import type { MonthlyShiftSlotSummary } from '../../domain/monthlyShiftSlot';
import type {
  MonthlyShiftSlotSummaryRepository,
  MonthlyShiftSlotSummaryListResult
} from '../../application/monthlyShiftSlot/ports/MonthlyShiftSlotSummaryRepository';
import { monthlyShiftSlotApi } from '../api/monthlyShiftSlotApi';

/**
 * 月次シフト枠サマリー Repository 具象実装
 *
 * @description
 * MonthlyShiftSlotSummaryRepository インターフェースの具象実装。
 * API Clientを使用してバックエンドAPIと通信し、
 * snake_case から camelCase への変換を行う。
 *
 * @implements {MonthlyShiftSlotSummaryRepository}
 */
export class MonthlyShiftSlotSummaryRepositoryImpl implements MonthlyShiftSlotSummaryRepository {
  /**
   * 月次シフト枠サマリー一覧を取得する
   *
   * @param {object} filter - フィルタ条件
   * @param {number} [filter.page] - ページ番号
   * @param {number} [filter.pageSize] - 1ページあたりの件数
   * @returns {Promise<MonthlyShiftSlotSummaryListResult>} camelCase変換済みの一覧結果
   */
  async findAll(filter: { page?: number; pageSize?: number }): Promise<MonthlyShiftSlotSummaryListResult> {
    const params: { page?: number; page_size?: number } = {};

    if (filter.page !== undefined) {
      params.page = filter.page;
    }
    if (filter.pageSize !== undefined) {
      params.page_size = filter.pageSize;
    }

    const response = await monthlyShiftSlotApi.getSummaryList(params);

    // APIレスポンスは既にcamelCase
    const data: MonthlyShiftSlotSummary[] = response.data.map(item => ({
      id: item.id,
      year: item.year,
      month: item.month,
      status: item.status,
      submissionRate: item.submissionRate,
      unconfirmedSlots: item.unconfirmedSlots,
      createdAt: '',
      updatedAt: ''
    }));

    return {
      data,
      meta: {
        currentPage: response.meta.current_page,
        lastPage: response.meta.last_page,
        perPage: response.meta.per_page,
        total: response.meta.total
      }
    };
  }

  /**
   * 月次シフト枠を削除する
   *
   * @param {string} id - 削除対象の月次シフト枠ID
   * @returns {Promise<void>}
   * @throws {Error} 削除失敗時
   */
  async delete(id: string): Promise<void> {
    await monthlyShiftSlotApi.delete(id);
  }
}

export const monthlyShiftSlotSummaryRepository = new MonthlyShiftSlotSummaryRepositoryImpl();
